import { createSelector } from 'reselect';

const selectTags = (state: any) => state.tags;


export const selectTagsCurrentItem = createSelector([selectTags], (tags) => tags.current);

export const selectTagsListItems = createSelector([selectTags], (tags) => tags.list);

export const selectTagsItemById = (itemId: any) =>
    createSelector(selectTagsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTagQueryItems = createSelector([selectTags], (tags) => tags.query);

export const selectTagCreatedItem = createSelector([selectTags], (tags) => tags.create);

export const selectTagUpdatedItem = createSelector([selectTags], (tags) => tags.update);

export const selectTagReadItem = createSelector([selectTags], (tags) => tags.read);

export const selectTagDeletedItem = createSelector([selectTags], (tags) => tags.delete);

export const selectTagSearchedItems = createSelector([selectTags], (tags) => tags.search);

export const selectTagItemsCount = createSelector([selectTags], (tags) => tags.count);

export const selectTagItemsFilter = createSelector([selectTags], (tags) => tags.filter);